import { CodeArticleVersion, Languages } from '@livv/models';
import { Box } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { getVersionLabel, getVariant } from './utils';
import ClickableEntry from '@components/Timeline/ClickableEntry';
import { TimelinePositioningProps } from '@components/Timeline/types';

interface VersionProps extends TimelinePositioningProps {
    comparisonMode: boolean;
    setVersionsSelected: (versions: CodeArticleVersion[]) => void;
    version: CodeArticleVersion;
    versionsSelected: CodeArticleVersion[];
}

const Version: FC<VersionProps> = ({
    comparisonMode,
    setVersionsSelected,
    version,
    versionsSelected,
    ...timelinePositioningProps
}) => {
    const { lang, t } = useTranslation('codeArticle');
    const { dateDebut, dateFin, etat, legifranceId } = version;
    const isDisplayedVersion = versionsSelected[0].legifranceId === version.legifranceId;
    const variant = getVariant(versionsSelected, legifranceId);
    const twoVersionSelected = versionsSelected.length === 2;
    const displayedDate = getVersionLabel(dateDebut, dateFin, t, etat, lang as Languages);

    const handleClick = () => {
        if (comparisonMode) {
            setVersionsSelected([versionsSelected[0], version]);
        } else {
            setVersionsSelected([version]);
        }
    };

    return (
        <ClickableEntry
            content={
                <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                    {displayedDate}
                </Box>
            }
            disabled={twoVersionSelected && comparisonMode}
            isActive={isDisplayedVersion}
            onClick={handleClick}
            title={t(`version${['PERIME', 'MODIFIE'].includes(etat) ? etat : ''}`)}
            variant={variant}
            {...timelinePositioningProps}
        />
    );
};

export default Version;
